import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import Swiper from 'swiper';
import { KlaHttpService } from '../services/kla.http.service';
import { CommonModule } from '@angular/common';
import { TitleComponent } from '../title/title.component';

@Component({
  selector: 'kla-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  standalone: true,
  imports: [ CommonModule, TitleComponent ]
})
export class CarouselComponent implements OnInit, AfterViewInit {

  readonly swiperId = this.makeId(7);
  @Input() config: any;
  @Input() lineConfig: any;
  swiperOptions: any;
  titleConfig: any;
  private readonly fullWidthSwiperOptions = {
    slidesPerView: 2,
    loop: true,
    spaceBetween: -200,
    centeredSlides: true,
    effect: 'coverflow',
    autoplay: {
      delay: 2000
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      clickable: true,
      el: '.swiper-pagination',
      type: 'bullets',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: -150
      }
    },
    coverflowEffect: {
      slideShadows: false,
      depth: 40,
      rotate: 5,
      scale: 0.8
    }
  };
  private readonly sideSwiperOptions = {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 0,
    centeredSlides: true,
    effect: 'coverflow',
    breakpoints: {
      450: {
        slidesPerView: 2,
        spaceBetween: -330
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 2000
    },
    pagination: {
      clickable: true,
      el: '.swiper-pagination',
      type: 'bullets',
    },
    coverflowEffect: {
      slideShadows: true,
      depth: 780,
      rotate: 10,
      scale: 0.8
    }
  };

  constructor(
    private httpService: KlaHttpService
  ) {
  }

  ngOnInit(): void {
    this.titleConfig = {
      header: this.config.header,
      title: this.config.title,
      description: this.config.description,
      badges: this.config.badges
    };
    if (this.config.layout === 'full-width') {
      this.swiperOptions = this.fullWidthSwiperOptions;
    } else {
      this.swiperOptions = this.sideSwiperOptions;
    }
  }

  makeId(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  ngAfterViewInit(): void {
    const swiper = new Swiper(`#${this.swiperId}`, this.swiperOptions);
  }

  getImagePath(image) {
    const config  = {
      id: image.id,
      width: 700,
      cropConfig: image.crop_config
    };
    return this.httpService.getCroppedImagePath(config);
  }

}
